<div class="page-loader" [style.display]="isLoading ? 'block' : 'none'">
  <div class="sk-spinner sk-spinner-three-bounce" style="margin-top:20%">
    <div class="sk-bounce1" style="background-color: #f44336"></div>
    <div class="sk-bounce2" style="background-color: #f44336"></div>
    <div class="sk-bounce3" style="background-color: #f44336"></div>
  </div>
</div>
